<div class="m-t flex flex-justify-between">
    <p class="h3">{{'Dimensions & Details'|translate}}</p>
    <button class="bg-col-5 b-radius-max pos-relative ratio-1-1"
            [style.width.rem]="2.5"
            role="button"
            aria-label="Close"
            (click)="close()">
        <i class="flex flex-middle flex-justify-center top-0 left-0 right-0 bottom-0 pos-absolute icon-close"
           aria-hidden="true"></i>
    </button>
</div>

<product-view-dimensions-and-details [product]="content.product"
                                     [icons]="content.content.dimensions_icons"
                                     [topAttributes]="content.content.dimensionsTopAttributes"
                                     [sections]="content.content.dimensions_sections">
</product-view-dimensions-and-details>